import {createListFromArray} from "../../components/common/commonUtilities";

export const STATUS = { ACTIVE: "Active", DELETED: "Deleted" };

export const USER_TYPES = {All: "All", State: "State", District: "District"}

export const UserStatusList = createListFromArray([STATUS.ACTIVE, STATUS.DELETED]);
